import type { DirectoryCell } from './cell-store';

const UNPREFIXED = new Set(['apps', 'app', 'login', 'auth', 'cookie-policy', 'profile', 'users', 'settings', 'playground', 'presentation']);

export function parseOperatorId(pathname: string): string | undefined {
  const seg = pathname.match(/^\/([^/]+)/)?.[1];
  if (!seg || seg === 'm' || UNPREFIXED.has(seg)) return undefined;
  return seg;
}

export function marketHome(operatorId: string): string {
  return `/${operatorId}/apps`;
}

export function withoutCellPrefix(pathname: string): string {
  const op = parseOperatorId(pathname);
  if (!op) return pathname;
  const rest = pathname.slice(`/${op}`.length);
  return rest.startsWith('/') ? rest : rest ? `/${rest}` : '/';
}

export function withCellPrefix(pathname: string, operatorId: string | undefined | null): string {
  if (!operatorId || !pathname.startsWith('/')) return pathname;
  if (parseOperatorId(pathname)) return pathname;
  if (pathname === '/') return marketHome(operatorId);
  return `/${operatorId}${pathname}`;
}

function rewriteLegacyMarketPath(cells: DirectoryCell[], pathname: string): { cell: DirectoryCell; pathname: string } | undefined {
  const code = pathname.match(/^\/m\/([^/]+)/)?.[1];
  if (!code) return undefined;
  const rest = pathname.replace(/^\/m\/[^/]+/, '') || '/apps';
  const cell = cells.find((c) => c.code === code) ?? cells[0];
  return { cell, pathname: `/${cell.operator_id}${rest}` };
}

export function resolveCellNavigation(
  cells: DirectoryCell[],
  pathname: string,
  sessionOrgId?: string | null
): { cell: DirectoryCell; pathname: string } | { cell: null } {
  if (cells.length === 0) return { cell: null };

  const legacy = rewriteLegacyMarketPath(cells, pathname);
  if (legacy) return legacy;

  const urlOp = parseOperatorId(pathname);
  if (urlOp) {
    const match = cells.find((c) => c.operator_id === urlOp);
    if (match) return { cell: match, pathname };
    return { cell: cells[0], pathname: marketHome(cells[0].operator_id) };
  }

  const byOrg = sessionOrgId ? cells.find((c) => c.workos_organization_id === sessionOrgId) : undefined;
  const cell = byOrg ?? cells[0];
  if (pathname === '/' || pathname === '') return { cell, pathname: marketHome(cell.operator_id) };
  return { cell, pathname: `/${cell.operator_id}${pathname}` };
}
